export const environment = {
  production: true,
  apiUrl: 'https://api.pxshiv.com',
  baseUrl: 'https://pixshiv.com/'
};
